export default __webpack_public_path__ + "device_stick_up_cam_pro.011f5762.png";